import React, { useEffect, useState } from "react";
import moment from "moment";
import { MdFilterListAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getAllDepositRequests } from "../../Server/api";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
const DepositeComplete = ({ userId }) => {
  const [depositList, setDepositList] = useState([]);
  // const [totalDepositAmount, settotalDepositAmount] = useState([]);
  const [loading, setLoading] = useState(true);

  const [totalPages, setTotalPages] = useState(1);

 const [page, setPage] = useState(1);
  const [limit] = useState(50);
  const [total, setTotal] = useState(0);
  const [fillter, setFillter] = useState(false);
  const [totalDepositAmount, setTotalDepositAmount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  // alert(totalDepositAmount)
  const [filters, setFilters] = useState({
    userId: "",
    mobile: "",
    from_date: "",
    to_date: ""
  });

  const navigate = useNavigate();

  const ucWords = (str) => {
    if (!str || typeof str !== "string") return "";
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  useEffect(() => {
    fetchDepositList(page);
  }, [page, userId]);
  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const handleClearFilter = () => {
    setFilters({
      userId: "",
      mobile: "",
      from_date: "",
      to_date: ""
    });
setPage(1);
    setTimeout(() => fetchDepositList(1), 100);
  };

  const handleFilter = () => {
setPage(1);
    fetchDepositList(1);
  };

  const fillterdata = () => {
    setFillter(prev => !prev);
  };

  const fetchDepositList = async (page = 1) => {
    setLoading(true);
    try {
      // Build params object with correct parameter names
      const params = {
        page,
        limit,
        status: 'success'
      };

      // Add filters only if they have values
      if (filters.userId) {
        params.userId = filters.userId;
      }

      if (filters.mobile) {
        params.mobile = filters.mobile;
      }

      if (filters.from_date) {
        params.from_date = filters.from_date;
      }

      if (filters.to_date) {
        params.to_date = filters.to_date;
      }
      const result = await getAllDepositRequests(params);
      if (result.data.success) {
        const approvedList = (result.data.data || []).filter(
          (item) => item.status?.toLowerCase() === "success"
        );
        setDepositList(approvedList);
                if (result.data.pagination) {
          setTotalPages(result.data.pagination.totalPages || 1);
          setTotalRecords(result.data.pagination.totalRecords || 0);
        } else if (result.pagination) {
          setTotalPages(result.pagination.totalPages || 1);
          setTotalRecords(result.pagination.totalRecords || 0);
        } else {
          // अगर pagination नहीं है तो total pages calculate करें
          const total = result.data.total || result.data.count || approvedList.length;
          const calculatedPages = Math.ceil(total / limit);
          setTotalPages(calculatedPages || 1);
          setTotalRecords(total);
        }
        
        setTotalDepositAmount(result.data.summary?.totalDepositAmount || 0);
      } else {
        setDepositList([]);
        setTotalPages(1);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      setDepositList([]);
      setTotalPages(1);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

const handlePrevPage = () => {
  if (page > 1) {
    setPage((prev) => prev - 1);
  }
};

const handleNextPage = () => {
  if (page < totalPages) {
    setPage((prev) => prev + 1);
  }
};

const handlePageClick = (pageNo) => {
     setPage(pageNo);
  };

  // Pagination component
const getPageNumbers = () => {
  const pageNumbers = [];
  const maxVisiblePages = 2;

  let startPage = Math.max(1, page - 2);
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // adjust start if near end
  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return pageNumbers;
};

  return (
    <div className="mt-3">
      <div className="card">
        <div className="card-header bg-color-black">
          <div className="d-flex align-items-center justify-content-between">
            <h3 className="card-title text-white d-flex align-items-center gap-4">Deposit Completed List <div className="d-flex justify-content-end">
              <h5 className="mb-0 bg-light text-dark p-2 rounded">
                Total Deposit Amount: ₹ {totalDepositAmount}
              </h5>
            </div>
            </h3>


            <div className="">
              <div className="fillterbutton" onClick={fillterdata}>
                <MdFilterListAlt /> Filter
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          {fillter && (
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="form-design-fillter gap-2 d-flex flex-wrap justify-content-between align-items-end">
                  {/* <div className="form_latest_design">
                    <div className="label">
                      <label htmlFor="">   Total Deposit Amount</label>
                    </div>
                    : ₹ {totalDepositAmount}

                  </div> */}

                  <div className="form_latest_design">
                    <div className="label">
                      <label htmlFor="">Mobile Number</label>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      value={filters.mobile}
                      onChange={(e) => handleFilterChange('mobile', e.target.value)}
                      placeholder="Enter Mobile Number"
                    />
                  </div>

                  <div className="form_latest_design">
                    <div className="label">
                      <label htmlFor="">From Date</label>
                    </div>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.from_date}
                      onChange={(e) => handleFilterChange('from_date', e.target.value)}
                    />
                  </div>

                  <div className="form_latest_design">
                    <div className="label">
                      <label htmlFor="">To Date</label>
                    </div>
                    <input
                      type="date"
                      className="form-control"
                      value={filters.to_date}
                      onChange={(e) => handleFilterChange('to_date', e.target.value)}
                    />
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      className="refreshbutton"
                      onClick={handleFilter}
                    >
                      Apply Filter
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleClearFilter}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Order ID</th>
                      <th>User Mobile</th>
                      <th>Amount</th>
                      <th>Gateway Name</th>
                      <th>Gateway Type</th>
                      <th>UTR NO</th>
                      <th>Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {depositList.length > 0 ? (
                      depositList.map((item, index) => (
                        <tr key={item._id}>
                          <td>{(page - 1) * limit + index + 1}</td>
                          <td>{item.date_time}</td>
                          <td>{item.order_id || "Admin"}</td>
                          <td>{item.mobile || "N/A"}</td>
                          <td>₹ {item.amount}</td>
                          <td>{item.getway_name || "N/A"}</td>
                          <td>{item.deposit_type || "N/A"}</td>
                          <td>{item.utr || "N/A"}</td>
                          <td>
                            {item?.image ? (
                              <img
                                src={`https://payment.lovebite247.com/uploads/${item.image.replace(/\\/g, "/")}`}
                                alt="deposit slip"
                                style={{ width: "70px", height: "70px", objectFit: "cover" }}
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Section - हमेशा दिखेगा अगर totalPages > 1 */}
                 {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4">
          
              <div className="sohwingallentries">
                Showing {(page - 1) * limit + 1} to{" "}
                {Math.min(page * limit, total)} of {total} entries
              </div>
          
              <div className="paginationall d-flex align-items-center gap-2">
          
                {/* PREV BUTTON */}
                <button
                  className="d-flex justify-content-center align-items-center"
                  disabled={page === 1}
                  onClick={handlePrevPage}
                >
                  <MdOutlineKeyboardArrowLeft />
                </button>
          
                {/* PAGE NUMBERS */}
                <div className="d-flex gap-1">
                  {getPageNumbers().map((pageNo) => (
                    <button
                      key={pageNo}
                       className={`paginationnumber ${pageNo === page ? "active" : ""
                        }`}
                      onClick={() => handlePageClick(pageNo)}
                    >
                      {pageNo}
                    </button>
                  ))}
                </div>
          
                {/* NEXT BUTTON */}
                <button
                  className="d-flex justify-content-center align-items-center "
                  disabled={page === totalPages}
                  onClick={handleNextPage}
                >
                  <MdOutlineKeyboardArrowRight />
                </button>
          
              </div>
            </div>
          )}
          
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DepositeComplete;